import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
// import { getSeedFileInfo } from "../../../api";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import MultipleLoadingScreen from "../../../design-system/MultipleLoadingScreen";
// import LoadingDots from "../../../design-system/LoadingDots";
import { Typography } from "@material-tailwind/react";
import useRefreshToken from "../../../utils/useRefreshToken";
import { isTokenExpired } from "../../layout/Layout";
import { useNavigate } from "react-router-dom";
import { delete_user_data_from_client_side } from "../../../utils/common";
import ReactQuill from "react-quill";
import { cleanTitle } from "../../../components/SeedItem/ShowPublishedExclusiveItemInSeedSearch";
import { RxCross2 } from "react-icons/rx";
import { getSeedFileInfo } from "../../../api/axiosApi";

const ShowCitationSource = ({ open, onClose, handleSave, fileName }: any) => {
    const [seedFileData, setSeedFileData] = useState<any>();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [seedDetailsAsString, setSeedDetailsAsString] = useState<string>();
    const refreshToken = useRefreshToken();
    const navigate = useNavigate();
    const size = window.innerWidth * 0.5;

    function formatDate(dateString:string) {
        if (!dateString) return null;
        
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return null;
      
        return date.toISOString().split('T')[0];
      }

    async function fetchSeedsInfo(seedFileName: string) {
        setIsLoading(true);
        // setTimeout(async () => {
        try {
            seedFileName = seedFileName.substring(0, seedFileName.lastIndexOf("."));
            // const access_token = localStorage.getItem("access_token");
            // const flag = isTokenExpired(access_token);
            // // console.log("flag: ", flag)
            // if (flag) {
            //     await refreshToken();
            // }
            const seedFileData = await getSeedFileInfo(seedFileName);
            // if (seedFileData.status === 401 || seedFileData.status === 422) {
            //     delete_user_data_from_client_side();
            //     navigate("/user_login");
            // }
            // if (!seedFileData.ok) {
            //     throw new Error(`Error! status: ${seedFileData.status}`);
            // }
            const seedData = await seedFileData.data;
            // console.log("seedData: ", seedData);
            setSeedFileData(seedData);
        } catch (error: any) {
            console.error(`Failed to fetch source info `, error);
            setError(error.message); // Set error message when request fails
        } finally {
            setIsLoading(false);
        }
        // },  1000);
    }

    useEffect(() => {
        fetchSeedsInfo(fileName);
    }, []);

    const drawerContent = isLoading ? (
        <div className=" p-5  justify-center items-center h-full">
            <div className="max-w-full animate-pulse">
                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-6/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
                <Typography as="div" variant="paragraph" className="mt-10 mb-2 h-2 w-4/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-2/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
                <Typography as="div" variant="paragraph" className="mt-10 mb-2 h-2 w-2/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
                <Typography as="div" variant="paragraph" className=" mb-2 h-2 w-11/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
                <Typography as="div" variant="paragraph" className=" mb-2 h-2 w-11/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
                <Typography as="div" variant="paragraph" className=" mb-2 h-2 w-11/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
                <Typography as="div" variant="paragraph" className=" mb-2 h-2 w-11/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
            </div>
        </div>
    ) : error ? (
        <div className="p-5 text-center font-bold">
            <h2>Oops, something went wrong.</h2>
            <p>{error}</p>
        </div>
    ) : (
        <div>
            <RxCross2 className="p-2 cursor-pointer" size={36} onClick={onClose}/>

            <div className="px-3 pb-20  ">
                {seedFileData?.title && (
                    <div className="flex mb-5 text-lg justify-center">
                        <h1>
                            {/* <span className="font-bold"> Title: </span> */}
                            {/* {seedFileData?.title} */}
                            {seedFileData.private ? (
                                <span className=" text-green-800 ">{cleanTitle(seedFileData?.title.toString())} </span>
                            ) : (
                                <a href={seedFileData?.link} target="_blank" className=" text-green-800 cursor-pointer hover:underline">
                                    {seedFileData?.title.toString().replace(/_/g, " ")}{" "}
                                </a>
                            )}
                        </h1>
                    </div>
                )}
                {seedFileData?.author && (
                      <div className="flex mb-5 w-full">
                      {/* <h5>
                        <span className="font-bold">Author: </span>
                        {seedFileData?.author}
                      </h5>
                      <p className="">
                        <span className="font-bold">Date: </span>
                        {seedFileData?.date}
                      </p> */}
                      <div className="w-full text-left">
                        <span className="font-bold">Author: </span>
                        {seedFileData?.author}
                      </div>
                      <div className="w-full text-right">
                        <span className="font-bold">Date: </span>
                        {seedFileData?.date ? (
                                formatDate(seedFileData.date)
                        ):""}
                      </div>
                    </div>
                )}
                {seedFileData?.description && (
                    <div className="mb-5 text-justify">
                        <h3 className="font-bold">Description:</h3>
                        {/* <p>{seedFileData?.description}</p> */}
                        <div className=" min-w-96">
                            <ReactQuill
                                // theme="snow"
                                modules={{ toolbar: false }}
                                readOnly={true}
                                value={seedFileData?.description}
                                // modules={{ toolbar: false }}
                                // formats={[]}
                                // readOnly={true}
                                className=""
                                style={{
                                    backgroundColor: "white",
                                    height: "60vh"
                                    // marginTop:"1rem"
                                }}
                            />
                        </div>
                    </div>
                )}
                {seedFileData?.suggestion && (
                    <div className="mb-5 text-justify">
                        <h2 className="font-bold">Suggestion:</h2>
                        <p className="pb-10">{seedFileData?.suggestion}</p>
                    </div>
                )}
                {!seedFileData?.title && !seedFileData?.author && !seedFileData?.description && !seedFileData?.suggestion && (
                    <div className="text-center font-bold">
                        <h2>Source not found.</h2>
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <div className="">
            <Drawer
                open={open}
                onClose={onClose}
                direction="right"
                size={size}
                duration={1000}
                className={`bg-gray-150 border-2 border-solid border-gray-400 mt-16 overflow-auto mb-10 scroll`}
            >
                {drawerContent}
            </Drawer>
        </div>
    );
};

export default ShowCitationSource;
